import { render, staticRenderFns } from "./ReturnChangePop.vue?vue&type=template&id=77615b33"
import script from "./ReturnChangePop.vue?vue&type=script&lang=js"
export * from "./ReturnChangePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77615b33')) {
      api.createRecord('77615b33', component.options)
    } else {
      api.reload('77615b33', component.options)
    }
    module.hot.accept("./ReturnChangePop.vue?vue&type=template&id=77615b33", function () {
      api.rerender('77615b33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ReturnChangePop.vue"
export default component.exports